import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CONFIG } from "./config/google";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  process.env.NODE_ENV === "production" ? (
    <React.StrictMode>
      <GoogleOAuthProvider clientId={GOOGLE_CONFIG.CLIENT_ID}>
        <App />
      </GoogleOAuthProvider>
    </React.StrictMode>
  ) : (
    <GoogleOAuthProvider clientId={GOOGLE_CONFIG.CLIENT_ID}>
      <App />
    </GoogleOAuthProvider>
  )
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
